import request from "../Utils/request";

export function deleteData(url: string) {
  return request.delete(url);
}
